// extracted by mini-css-extract-plugin
export default {"highlights":"highlights--mp-T2tnf","price-text-container":"price-text-container--mp-USEq9","priceTextContainer":"price-text-container--mp-USEq9"};